export default (state, { payload }) => (
    {
        ...state,
        viewBox: {
            ...payload,
        },
    }
);
